import * as React from 'react';
import { useSelector } from 'react-redux';

import { OfferStatsContainer } from './OfferStats';
import { OfferMetaData } from '../../components/OfferMetaData/OfferMetaData';
import { OfferValueAddedServicesContainer } from '../../components/offer_value_added_services/container';
import { selectIsInHiddenBase } from '../../selectors/offerData/selectIsInHiddenBase';
import { selectOfferAdded } from '../../selectors/offerData/selectOfferAdded';

export const OfferMetaDataContainer = () => {
  const isInHiddenBase = useSelector(selectIsInHiddenBase);
  const offerAdded = useSelector(selectOfferAdded);

  return (
    <OfferMetaData
      added={offerAdded && `Обновлено: ${offerAdded}`}
      stats={<OfferStatsContainer />}
      values={<OfferValueAddedServicesContainer />}
      isInHiddenBase={isInHiddenBase}
    />
  );
};
